exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".select[data-v-176f4850] {\n  padding-left: 10px;\n  border-radius: 5px;\n  border: solid 1px #e8e3e3;\n  background-color: #ffffff;\n  width: 20%;\n}\n@media (max-width: 990px) {\n.select[data-v-176f4850] {\n      width: 30%;\n}\n}\n@media (max-width: 700px) {\n.select[data-v-176f4850] {\n      display: block;\n      width: 96%;\n}\n}\n", ""]);

// exports
